//攻略请求

import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
// import { debuglog } from 'util';
import qs from "qs"; // 根据需求是否导入qs模块


const order = {
    //更新出行人信息body
    tripInsertOrUpdatePeopleInfo(params) {
        return axios.post(`${base.fm}/user/trip/people/update`, params);
    },
     //更新出行人信息form
     tripInsertOrUpdatePeopleInfoForm(params) {
        return axios.post(`${base.fm}/user/trip/people/update/form`, qs.stringify(params));
    },
     //更新收货人信息body
     userUpdateAddr(params) {
        return axios.post(`${base.fm}/user/addr/update`, params);
    },
 
}

export default order;


// WEBPACK FOOTER //
// ./src/api/order.js